import type { DashboardWidget, ReportField } from '@/lib/cube-report'

export function field(widget: DashboardWidget, member: string): ReportField {
  return widget.fields.get(member) as ReportField
}

/** Ctrl (Mac'te Meta) basılıysa seçime ekler/çıkarır (çapraz filtre). */
export const isAdditive = (event: { ctrlKey?: boolean; metaKey?: boolean } | undefined) =>
  Boolean(event?.ctrlKey || event?.metaKey)

/** Boş değer seçim olamaz; yalnız düz metin dimension'ları (zaman/sayı `equals` ile süzülmez). */
export function selectableValue(item: ReportField, value: unknown): string | undefined {
  if (item.type !== 'string' || item.image) return undefined
  return value === null || value === undefined || value === '' ? undefined : String(value)
}
